module.exports = __webpack_public_path__ + "img/model-icon.77d88f1a.png";